<template>
  <footer id="footer">
    ©️2020 上海易氩软件有限公司&nbsp;&nbsp; <a style="color:#fff" href="http://www.shca.gov.cn/">沪ICP备19021575号-2</a>
  </footer>
</template>

<script>
export default {
  name: "CommonFooter"
};
</script>
<style>
#footer { 
  width:100%;
  text-align: center;
  line-height: 35px;
  height: 35px;
  background-color: #333a40;
  color: #fff;
  font-size: 12px;
}
</style>
